export const matchPx = /px$/;

export function fromPx(px, defaultValue) {
  const type = typeof px;
  return type === 'number' ? px : (type !== 'string' || !px) ? defaultValue
    : +px.replace(matchPx, '');
}
